__turbopack_context__.v({
  "root": "ChatbotsUpsell-module__P-SLmW__root",
});
